<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,802.5c-0.24-2.14-1.01-3.92-1.37-5.2c-0.37-0.11-0.72-0.25-1.05-0.43c-1.16,0.65-2.96,1.35-4.65,2.7
	c1.35-1.68,2.04-3.49,2.7-4.65c-0.18-0.33-0.32-0.68-0.43-1.05c-1.28-0.36-3.05-1.13-5.2-1.37c2.14-0.24,3.92-1.01,5.2-1.37
	c0.11-0.37,0.25-0.72,0.43-1.05c-0.65-1.16-1.35-2.96-2.7-4.65c1.68,1.35,3.49,2.04,4.65,2.7c0.33-0.18,0.68-0.32,1.05-0.43
	c0.36-1.28,1.13-3.05,1.37-5.2c0.24,2.14,1.01,3.92,1.37,5.2c0.37,0.11,0.72,0.25,1.05,0.43c1.16-0.65,2.96-1.35,4.65-2.7
	c-1.35,1.68-2.04,3.49-2.7,4.65c0.18,0.33,0.32,0.68,0.43,1.05c1.28,0.36,3.05,1.13,5.2,1.37c-2.14,0.24-3.92,1.01-5.2,1.37
	c-0.1,0.37-0.25,0.72-0.43,1.05c0.65,1.16,1.35,2.96,2.7,4.65c-1.68-1.35-3.49-2.04-4.65-2.7c-0.33,0.18-0.68,0.32-1.05,0.43
	C1.51,798.58,0.74,800.36,0.5,802.5z M0.5,795c0.69,0,1.32-0.27,1.78-0.72S3,793.19,3,792.5s-0.27-1.33-0.72-1.78S1.19,790,0.5,790
	s-1.32,0.27-1.78,0.72S-2,791.81-2,792.5s0.27,1.33,0.72,1.78S-0.19,795,0.5,795z"/>
</svg>

</template>